import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "../components/ui/button";
import { ArrowLeftIcon } from "@heroicons/react/24/outline";

const API_BASE = "https://bayautomation-qctracker.co.za/api";
const authHeaders = () => {
  const token = localStorage.getItem("token") || "";
  return token ? { Authorization: `Bearer ${token}` } : {};
};

  const FIXED_RECIPIENT = "admin@bayautomation.co.za";

export default function CommsPage() {
  const navigate = useNavigate();
  const token = localStorage.getItem("token") || "";

  useEffect(() => {
    if (!token) navigate("/", { replace: true });
  }, [token, navigate]);

  // To is fixed and enforced
  const [to] = useState(FIXED_RECIPIENT);
  const [subject, setSubject] = useState("");
  const [body, setBody] = useState("");
  const [sending, setSending] = useState(false);

  const sendEmail = async () => {
    if (!subject.trim() || !body.trim()) {
      alert("Please fill To, Subject and Message.");
      return;
    }
    setSending(true);
    try {
      const res = await fetch(`${API_BASE}/comms/email`, {
        method: "POST",
        headers: { "Content-Type": "application/json", ...authHeaders() },
        body: JSON.stringify({ to: FIXED_RECIPIENT, subject, body }),
      });
      if (!res.ok) throw new Error(await res.text());
      alert("Email sent ✅");
      navigate(-1);
    } catch (e) {
      console.error("Comms send failed:", e);
      alert("Failed to send email. Check console for details.");
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="min-h-screen p-6 max-w-3xl mx-auto">
      <div className="flex items-center justify-between mb-6">
        <h1 className="text-2xl font-bold">Comms</h1>
        <Button variant="secondary" onClick={() => navigate(-1)}>← Back</Button>
      </div>

      <div className="space-y-4">
        <div>
          <label className="block text-sm font-medium mb-1">To (locked)</label>
       <input
         type="text"
         value={to}
         readOnly
         aria-readonly="true"
         className="border rounded w-full p-2 bg-gray-100 text-gray-700 cursor-not-allowed"
       />
       <p className="text-xs text-gray-500 mt-1">
         Recipient is fixed to {to}.
       </p>
        </div>
        <div>
          <label className="block text-sm font-medium mb-1">Subject</label>
          <input
            type="text"
            value={subject}
            onChange={(e) => setSubject(e.target.value)}
            className="border rounded w-full p-2"
            placeholder="Subject"
          />
        </div>
        <div>
          <label className="block text-sm font-medium mb-1">Message</label>
          <textarea
            rows={12}
            value={body}
            onChange={(e) => setBody(e.target.value)}
            className="border rounded w-full p-2 font-mono"
            placeholder="Type your message..."
          />
        </div>

        <div className="flex items-center gap-2">
          <Button variant="secondary" onClick={() => navigate(-1)}>Cancel</Button>
          <Button onClick={sendEmail} disabled={sending}>
            {sending ? "Sending..." : "Send Email"}
          </Button>
        </div>
      </div>
    </div>
  );
}